import { render, staticRenderFns } from "./BannerForm.vue?vue&type=template&id=41ff2142&scoped=true"
import script from "./BannerForm.vue?vue&type=script&lang=js"
export * from "./BannerForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41ff2142",
  null
  
)

export default component.exports